import { type FragmentType, graphql, useFragment } from "@repo/graphql-types";
import { CpsAvatar } from "corpus";
import { useRouteContext, useRouter } from "@tanstack/react-router";
import { Right } from "@repo/icons";
import { getImageSourceFromBase64 } from "@/lib/image-source";
import { BadgeV2Icon, BadgeV2Root } from "@/components/badge-v2.tsx";

export const HomeProfileHeaderFragment = graphql(`
  fragment HomeProfileHeaderFragment on query_root {
    profilePictureFile: LivanceApiSelecionaFotoDePerfil(arg1: { codUsuario: $userId }) {
      arquivo
      mimetype
    }
  }
`);

interface HomeProfileHeaderProps {
  data: FragmentType<typeof HomeProfileHeaderFragment>;
}

export const HomeProfileHeader = ({ data }: HomeProfileHeaderProps): JSX.Element => {
  const fragmentData = useFragment(HomeProfileHeaderFragment, data);
  const router = useRouter();
  const { user } = useRouteContext({
    strict: false,
  });

  const memberName = user.apelido ?? user.nome;

  const imageSrc = getImageSourceFromBase64(
    fragmentData.profilePictureFile?.mimetype,
    fragmentData.profilePictureFile?.arquivo,
  );

  const handleOnClickProfile = (): void => {
    void router.navigate({ to: "/settings/profile" });
  };

  return (
    <button
      type="button"
      className="flex flex-row w-full h-[56px] py-2 gap-2 rounded-lg"
      onClick={handleOnClickProfile}
    >
      <CpsAvatar initials={memberName} src={imageSrc} size={40} alt="Sua foto" />
      <div className="flex flex-col">
        <BadgeV2Root className="bg-primary-400 text-black">
          MEU PERFIL
          <BadgeV2Icon className="fill-black" Icon={Right} />
        </BadgeV2Root>
        <h1 className="font-medium text-md">Olá, {memberName}</h1>
      </div>
    </button>
  );
};
